import { cn } from "@/lib/utils";

const PRIORITY_MAP = {
  high: { label: "High", cls: "bg-priority-bg text-priority-text border-priority-border" },
  medium: { label: "Medium", cls: "bg-brand-soft text-brand border-brand-connector" },
  low: { label: "Low", cls: "bg-slate-50 text-ink-400 border-slate-200" },
};

export const PriorityBadge = ({ priority = "low", className }) => {
  const p = PRIORITY_MAP[priority] || PRIORITY_MAP.low;
  return (
    <span
      data-testid={`priority-badge-${priority}`}
      className={cn(
        "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold border tracking-wide",
        p.cls, className
      )}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full",
        priority === "high" ? "bg-priority-text" : priority === "medium" ? "bg-brand" : "bg-ink-300")} />
      {p.label}
    </span>
  );
};

export const StatusPill = ({ status, done }) => (
  <span className={cn("inline-flex items-center gap-1.5 text-xs font-medium", done ? "text-done-text" : "text-brand")}>
    <span className={cn("h-1.5 w-1.5 rounded-full", done ? "bg-done-text" : "bg-brand animate-pulse")} />
    {status}
  </span>
);

export const Progress = ({ value = 0, done }) => (
  <div className="h-1.5 w-full rounded-full bg-slate-100 overflow-hidden">
    <div className={cn("h-full rounded-full transition-all duration-700", done ? "bg-done-text" : "bg-brand")} style={{ width: `${value}%` }} />
  </div>
);

export const Avatar = ({ src, alt, size = "h-7 w-7" }) => (
  <img src={src} alt={alt} className={cn(size, "rounded-full object-cover ring-2 ring-white shadow-sm")} loading="lazy" />
);
